"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = Text;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useStyles_1 = require("~/useStyles");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    text: {
        // todo tie into media queries and use pixels
        fontSize: ({ size }) => {
            switch (size) {
                case "sm":
                    return "0.8em";
                case "lg":
                    return "1.2em";
                case "md":
                default:
                    return "1em";
            }
        },
        textTransform: ({ uppercase }) => (uppercase ? "uppercase" : "none"),
        fontFamily: ({ font }) => {
            switch (font) {
                case "cursive":
                    return theme.typography.accent;
                case "standard":
                default:
                    return theme.typography.primary;
            }
        },
        color: ({ light }) => {
            if (light) {
                return "#fff";
            }
            return "#000";
        },
        marginBottom: ({ tag, size }) => tag === "p" && size !== "sm" ? "0.5em" : "0",
        textAlign: ({ center }) => (center ? "center" : "left"),
    },
}));
function Text(props) {
    const classes = useStyles(props);
    const { children, tag = "span", className } = props;
    const Tag = tag;
    return React.createElement(Tag, { className: (0, classnames_1.default)(classes.text, className) }, children);
}
